import { ConfigurationProvider } from "../../../lib/infrastructure/configuration/ConfigurationProvider";

/** Identity Web's base URL from `App.IdentityWebUrl` (no trailing slash), or undefined when the environment has none. */
export function identityWebUrl(): string | undefined {
    const url = ConfigurationProvider.getConfiguration()?.App?.IdentityWebUrl?.trim();
    return url ? url.replace(/\/+$/, "") : undefined;
}

/** Identity Web's access-control (IAM) page for an Identity scope, the same page Ark.Core's `manageUrl` points to. */
export function identityWebIamUrl(scope: string): string | undefined {
    const base = identityWebUrl();
    return base ? `${base}/iam?scope=${encodeURIComponent(scope)}` : undefined;
}

/**
 * The Identity scope of a space. Spaces are not attached to the hierarchy yet (OrbitalPlan/18 §6, phase 3), so this is the
 * unattached form; an attached space would live at `{node}/ark.spaces/{id}`.
 */
export function spaceScope(spaceId: string | number): string {
    return `/products/ark/spaces/${spaceId}`;
}
